export default __webpack_public_path__ + "static/media/59_mobile.72838dc3.jpg";